import React, { useState } from "react";
import { useField } from "formik";
import Stack from "@mui/material/Stack";
import TextFieldLabel from "./TextFieldLabel";
import TextField from "@mui/material/TextField";
import { IoEye, IoEyeOff } from "react-icons/io5";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";

export default function InputTextField({
  label,
  requiredMark,
  placeholder,
  name,
  type = "text",
  hiddenPassword = false,
  ...props
}) {
  const [showPassword, setShowPassword] = useState(false);
  const [field, meta] = useField(name); // 🔑 connects field to Formik

  const isPasswordType = hiddenPassword && type === "password";

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <Stack spacing={1}>
      <TextFieldLabel label={label} required={requiredMark} />
      <TextField
        {...field}
        {...props}
        size="small"
        placeholder={placeholder}
        type={isPasswordType ? (showPassword ? "text" : "password") : type}
        autoComplete="off"
        error={meta.touched && Boolean(meta.error)} // ✅ show red border
        helperText={meta.touched && meta.error} // ✅ show error message
        InputProps={
          isPasswordType
            ? {
                endAdornment: (
                  <InputAdornment position="end" className="pr-2">
                    <IconButton onClick={handleTogglePassword} edge="end">
                      {showPassword ? (
                        <IoEyeOff className="w-5 h-5" />
                      ) : (
                        <IoEye className="w-5 h-5" />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }
            : {}
        }
      />
    </Stack>
  );
}
